import { apiClient } from "./ApiClient";
import { API_URLS } from "../constants";

export const SidoSiggService = {
  fetchSidos: async () => {
    try {
      const { data } = await apiClient.get(`${API_URLS.AREA.SIDO_LIST}`);
      return data;
    } catch (error) {
      throw error;
    }
  },
  fetchSiggs: async (sidoId) => {
    try {
      const { data } = await apiClient.get(`${API_URLS.AREA.SIGG_LIST}?sido_id=${sidoId}`);
      return data;
    } catch (error) {
      throw error;
    }
  },
};
